import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Send, Car, RefreshCw } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL + '/api';
const auth = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });

export const PublishNowButtons = () => {
  const [busy, setBusy] = useState('');

  const run = async (kind, confirmText) => {
    if (!window.confirm(confirmText)) return;
    setBusy(kind);
    try {
      const r = await axios.post(`${API}/admin/autopost/${kind}`, {}, { headers: auth() });
      (r.data.status === 'already' ? toast.info : toast.success)(r.data.message);
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Échec');
    }
    setBusy('');
  };

  const cls = 'flex items-center gap-2 px-4 py-2.5 rounded-lg font-medium text-sm transition-colors disabled:opacity-50';
  return (
    <div className="flex flex-wrap gap-2" data-testid="publish-now-buttons">
      <button disabled={!!busy} onClick={() => run('article-now', "Publier l'article du jour maintenant sur Facebook et Instagram? (Celui de 9 h ne sera pas republié aujourd'hui.)")}
        className={`${cls} bg-emerald-600 text-white hover:bg-emerald-700`} data-testid="publish-article-now-btn">
        {busy === 'article-now' ? <RefreshCw className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />} Publier l'article maintenant
      </button>
      <button disabled={!!busy} onClick={() => run('vehicles-now', 'Publier 2 véhicules maintenant sur Facebook?')}
        className={`${cls} bg-white border border-slate-200 text-slate-700 hover:bg-slate-50`} data-testid="publish-vehicles-now-btn">
        {busy === 'vehicles-now' ? <RefreshCw className="w-4 h-4 animate-spin" /> : <Car className="w-4 h-4" />} Publier les véhicules maintenant
      </button>
    </div>
  );
};
